import { type MenuItem } from '@/types/common';
import getLegalUrl from '@/utils/getLegalUrl';

const getMenuSign = (lang: string): MenuItem[] => [
  {
    label: 'common:menu.about',
    href: 'https://www.swipesign.io/{lang}',
    target: '_blank',
  },
  {
    label: 'common:menu.imprint',
    href: getLegalUrl('imprint', lang),
    target: '_blank',
  },
  {
    label: 'common:menu.privacyPolicy',
    href: getLegalUrl('privacy', lang),
    target: '_blank',
  },
  {
    label: 'common:menu.termsAndConditions',
    href: getLegalUrl('terms', lang),
    target: '_blank',
  },
];

export default getMenuSign;
